import { defineComponent, ref, computed, resolveComponent, openBlock, createElementBlock, normalizeClass, createElementVNode, createVNode, normalizeProps, guardReactiveProps, renderSlot, createTextVNode, toDisplayString, createBlock, withModifiers, createCommentVNode } from 'vue';
import { OrIndicatorV3 as script$1, IndicatorColor } from '../or-indicator-v3/index.js';
import { OrIconButtonV3 as script$2 } from '../or-icon-button-v3/index.js';
import '../or-icon-v3/index.js';
import '../OrAutocompleteV3-961163d0.js';
import '@vueuse/core';
import '@onereach/styles/screens.json';
import '@onereach/styles/tailwind.config.json';
import '../or-error-v3/index.js';
import '../or-hint-v3/index.js';
import '../or-input-box-v3/index.js';
import '../or-input-v3/index.js';
import '../OrInlineInputV3-4e69972f.js';
import '../or-inline-input-box-v3/index.js';
import '../or-text-v3/index.js';
import '../or-label-v3/index.js';
import '../or-loader-v3/index.js';
import '../or-menu-item-v3/index.js';
import '../or-tooltip-v3/index.js';
import '../or-popover-v3/index.js';
import '@floating-ui/dom';
import '../or-bottom-sheet-v3/index.js';
import '../or-overlay-v3/index.js';
import '../or-teleport-v3/index.js';
import '../or-tag-input-v3/index.js';
import '../or-tags-v3/index.js';
import '../or-button-v3/index.js';
import '../or-tag-v3/index.js';

var NotificationVariant;
(function (NotificationVariant) {
  NotificationVariant["Success"] = "success";
  NotificationVariant["Warning"] = "warning";
  NotificationVariant["Error"] = "error";
  NotificationVariant["Info"] = "info";
})(NotificationVariant || (NotificationVariant = {}));
const VariantToIconName = {
  [NotificationVariant.Success]: 'check_circle',
  [NotificationVariant.Warning]: 'warning',
  [NotificationVariant.Error]: 'error',
  [NotificationVariant.Info]: 'info'
};

const Notification = [
// Layout
'layout-row items-start',
// Shape
'rounded-md',
// Spacing
'px-md', 'py-md', 'gap-md',
// Typography
'typography-body-2-regular',
// Typography (children)
'[&_:any-link]:typography-body-2-bold',
// Elevation
'shadow-contextual', 'dark:shadow-contextual-dark',
// Theme
'theme-foreground-default', 'dark:theme-foreground-default-dark'];
const NotificationVariants = {
  [NotificationVariant.Success]: [
  // Theme
  'theme-background-success-container', 'dark:theme-background-success-container-dark',
  // Theme (children)
  '[&_:any-link]:theme-foreground-success', 'dark:[&_:any-link]:theme-foreground-success-dark'],
  [NotificationVariant.Warning]: [
  // Theme
  'theme-background-warning-container', 'dark:theme-background-warning-container-dark',
  // Theme (children)
  '[&_:any-link]:theme-foreground-warning', 'dark:[&_:any-link]:theme-foreground-warning-dark'],
  [NotificationVariant.Error]: [
  // Theme
  'theme-background-error-container', 'dark:theme-background-error-container-dark',
  // Theme (children)
  '[&_:any-link]:theme-foreground-error', 'dark:[&_:any-link]:theme-foreground-error-dark'],
  [NotificationVariant.Info]: [
  // Theme
  'theme-background-primary-container', 'dark:theme-background-primary-container-dark',
  // Theme (children)
  '[&_:any-link]:theme-foreground-primary', 'dark:[&_:any-link]:theme-foreground-primary-dark']
};

var script = defineComponent({
  name: 'OrNotification',
  components: {
    OrIndicator: script$1,
    OrIconButton: script$2
  },
  props: {
    variant: {
      type: String,
      default: () => NotificationVariant.Info
    },
    disableClose: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: undefined
    }
  },
  expose: ['root'],
  setup(props) {
    // Refs
    const root = ref();
    // Styles
    const rootStyles = computed(() => ['or-notification-v3', ...Notification, ...NotificationVariants[props.variant]]);
    const indicatorProps = computed(() => {
      const VariantToIndicatorColor = {
        [NotificationVariant.Success]: IndicatorColor.Success,
        [NotificationVariant.Warning]: IndicatorColor.Warning,
        [NotificationVariant.Error]: IndicatorColor.Error,
        [NotificationVariant.Info]: IndicatorColor.Neutral
      };
      return {
        icon: {
          icon: VariantToIconName[props.variant],
          variant: 'filled-bold'
        },
        color: VariantToIndicatorColor[props.variant],
        size: 'm'
      };
    });
    return {
      root,
      rootStyles,
      indicatorProps
    };
  }
});

const _hoisted_1 = {
  class: /*#__PURE__*/normalizeClass(['mt-[2px] md:mt-[2.5px]'])
};
const _hoisted_2 = {
  class: /*#__PURE__*/normalizeClass(['grow'])
};
const _hoisted_3 = {
  class: /*#__PURE__*/normalizeClass(['mt-[2px] md:mt-[2.5px]'])
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrIndicator = resolveComponent("OrIndicator");
  const _component_OrIconButton = resolveComponent("OrIconButton");
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles)
  }, [createElementVNode("div", _hoisted_1, [createVNode(_component_OrIndicator, normalizeProps(guardReactiveProps(_ctx.indicatorProps)), null, 16 /* FULL_PROPS */)]), createElementVNode("div", _hoisted_2, [renderSlot(_ctx.$slots, "default", {}, () => [createTextVNode(toDisplayString(_ctx.message), 1 /* TEXT */)])]), createElementVNode("div", _hoisted_3, [!_ctx.disableClose ? (openBlock(), createBlock(_component_OrIconButton, {
    key: 0,
    icon: 'close',
    size: 'm',
    onClick: _cache[0] || (_cache[0] = withModifiers($event => _ctx.$emit('close'), ["stop"]))
  })) : createCommentVNode("v-if", true)])], 2 /* CLASS */);
}

script.render = render;
script.__file = "src/components/or-notification-v3/OrNotification.vue";

export { NotificationVariant, script as OrNotificationV3, VariantToIconName };
